import type { SVGProps } from 'react';
const SvgKitchen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#kitchen_svg__a)">
      <path
        fill="currentColor"
        d="M18 2.01 6 2a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99ZM18 20H6v-9.02h12V20Zm0-11H6V4h12v5ZM8 5h2v3H8V5Zm0 7h2v5H8v-5Z"
      />
    </g>
    <defs>
      <clipPath id="kitchen_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKitchen;
